import { useState } from 'react';
import { CardGrid, CardGridItem } from 'src/components/cardGrid';
import { LayoutListCard } from 'src/components/cardGrid/layoutListCard';
import { NoResultAlert } from 'src/components/noResultAlert';
import { Progress } from 'src/components/progress';
import { SubHeaderWithSorting } from 'src/components/subHeader';
import { CardGridWrapper } from 'src/features/assemblies/listAssemblyPage/ListAssemblyPage.styled';
import { ILayout } from 'src/interfaces';
import { DataTestID } from 'src/utils';

import { LayoutListProps } from './LayoutList.interface';

export const LayoutList = (props: LayoutListProps) => {
  const [, setSelectedComponent] = useState<ILayout>();
  const onSelectedCard = (component: ILayout) => {
    setSelectedComponent(component);
  };

  return (
    <>
      {props.isLayoutsLoading ? (
        <Progress />
      ) : (
        <>
          <SubHeaderWithSorting
            title="Layouts"
            selectedSortOption={props.selectedSortOption}
            onSortChange={props.onSortChangeHandle}
            totalCount={props.layoutsDetails?.pages[0]?.totalCount}
            numResults={props.totalNumOfLayouts}
          />
          <NoResultAlert
            isLoading={props.isLayoutsLoading}
            dataToCheck={props.layoutsDetails?.pages?.flatMap(
              (item: { layouts: any }) => item.layouts,
            )}
          />
          <CardGridWrapper>
            <CardGrid
              isLoading={props.isLayoutsLoading}
              error={props.errorLayouts}
              updatePage={props.getNextLayoutPage}>
              {props.layoutsDetails?.pages?.map((page) =>
                page.layouts.map((layout, key) => (
                  <CardGridItem
                    item
                    key={key}
                    data-testid={DataTestID.LayoutListCard}>
                    <LayoutListCard
                      layout={layout}
                      onClicked={() => onSelectedCard(layout)}
                    />
                  </CardGridItem>
                )),
              )}
            </CardGrid>
          </CardGridWrapper>
        </>
      )}
    </>
  );
};
